import {
	CommunityListItem,
	listCommunities,
} from "client/Api/Workspace/LiveInformation/Hub/communityLiveInformation";

export class CommunityLiveInformationProvider {
	private _listRetrievalPromise: Promise<readonly CommunityListItem[]> | undefined;

	public listCommunities(): Promise<readonly CommunityListItem[]> {
		if (!this._listRetrievalPromise) {
			this._listRetrievalPromise = listCommunities();
		}
		return this._listRetrievalPromise;
	}
}